export default {
  sort: 5,
  path: '/orderProgress',
  name: 'order-progress',
  component: () => import('@/views/user/orderProgress.vue'),
}



// WEBPACK FOOTER //
// ./src/router/modules/orderProgress.js